import React from "react"
import AutoHide from "../AutoHide/AutoHide"
import { useIntl } from "react-intl"
import "./NewModuleTag.styles.scss"
import { isFeatureEnabled } from "config/feature-flags"

interface NewModuleTagProps {
	from: Date
	to: Date
}

const NewModuleTag: React.FC<NewModuleTagProps> = (props) => {
	const { from, to } = props
	const intl = useIntl()

	return (
		<>
			<AutoHide
				isVisible={isFeatureEnabled("newComponentTag")}
				start={from}
				end={to}
			>
				<span className="new-tag">
					{intl.formatMessage({ id: "phronesis.module.new" })}
				</span>
			</AutoHide>
		</>
	)
}

export default NewModuleTag
